import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  thumbnail: string;
  duration: string;
  quality: string;
  rating: number;
  views: string;
  category: string;
  isHot?: boolean;
  isNew?: boolean;
  tags?: string[];
}

export default function VideoCard({
  id,
  title,
  thumbnail,
  duration,
  quality,
  rating,
  views,
  isHot,
  isNew,
  tags,
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 hover:bg-background-100 transition-all duration-300"
      data-product-shop=""
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

        <div className="absolute top-2 left-2 flex items-center gap-1.5">
          <span className="px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
            {quality}
          </span>
          {isHot && (
            <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded whitespace-nowrap">
              热播
            </span>
          )}
          {isNew && (
            <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded whitespace-nowrap">
              新上
            </span>
          )}
        </div>

        <div className="absolute bottom-2 right-2">
          <span className="px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
            {duration}
          </span>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl"></i>
          </div>
        </div>
      </div>

      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            {rating}
          </span>
          <span>{views}次播放</span>
        </div>
        {tags && tags.length > 0 && (
          <div className="flex items-center gap-1.5 mt-2 flex-wrap">
            {tags.map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}